import React, { useState } from "react";
import { api, errMsg } from "../lib/api";
import { PwdInput } from "./LoginView";
import { KeyRound, Loader2 } from "lucide-react";

export default function PasswordGate({ t, user, onDone }) {
  const [ancien, setAncien] = useState("");
  const [nouveau, setNouveau] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(null);
    if (nouveau.length < 8) return setErr(t.pwd.tooShort);
    if (nouveau !== confirm) return setErr(t.pwd.mismatch);
    if (nouveau === ancien) return setErr(t.pwd.same);
    setBusy(true);
    try { await api.changePassword(ancien, nouveau); onDone(); } catch (ex) { setErr(errMsg(ex)); }
    setBusy(false);
  };
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(15,23,42,0.55)", backdropFilter: "blur(6px)", display: "grid", placeItems: "center", padding: 16 }} data-testid="password-gate">
      <form onSubmit={submit} className="card fade-up w-full" style={{ maxWidth: 440, padding: 32, background: "var(--bg)" }}>
        <div className="eyebrow mb-3 flex items-center gap-2"><KeyRound size={13} />{t.pwd.eyebrow}</div>
        <h2 className="font-h text-2xl mb-2">{t.pwd.title}</h2>
        <p className="text-sm mb-6" style={{ color: "var(--tx2)" }}>{t.pwd.sub} <span className="font-m">{user.email}</span></p>
        <label className="eyebrow block mb-1.5">{t.pwd.current}</label>
        <input type="password" className="inp mb-4" required autoComplete="current-password" value={ancien} onChange={(e) => setAncien(e.target.value)} data-testid="pwd-current" />
        <div className="mb-4"><PwdInput t={t} label={t.pwd.new} testid="pwd-new" autoComplete="new-password" value={nouveau} onChange={(e) => setNouveau(e.target.value)} /></div>
        <div className="mb-5"><PwdInput t={t} label={t.pwd.confirm} testid="pwd-confirm" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
        {err && <div className="text-sm mb-4 px-3 py-2" style={{ background: "rgba(220,38,38,0.08)", color: "var(--red)" }} data-testid="pwd-error">{err}</div>}
        <button className="btn btn-primary w-full justify-center" disabled={busy} data-testid="pwd-submit">{busy ? <Loader2 size={15} className="animate-spin" /> : <KeyRound size={15} />}{t.pwd.submit}</button>
      </form>
    </div>
  );
}
